import {
  Box,
  Card,
  CardContent,
  Paper,
  TableContainer,
  TablePagination,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslate } from 'react-admin';
import { AutocompleteSelectFieldMembers } from '../../components/AutocompleteSelectFieldMembers';
import { ResultsTable } from '../../components/ResultsTable';
import { SelectFieldTeams } from '../../components/SelectFieldTeams';
import { useUser } from '../../providers/userProvider';
import { apiUrl, httpClient } from '../../utils/httpUtils';
import { hasRole } from '../../utils/roles';

export const Results = ({ title, members = false, date, newData }) => {
  const t = useTranslate();
  const [data, setData] = useState(newData || []);
  const [teamSelected, setTeam] = useState('');
  const [selectedMember, setSelectedMember] = useState(null);
  const [teams, setTeams] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage] = useState(10);
  const [totalPerPage, setTotalPerPage] = useState(0);
  const { team: teamId, loading: userLoading } = useUser();

  const getResults = async () => {
    try {
      let params = [];
      if (teamId && !hasRole(['admin', 'gerente'])) {
        params.push(`team_id=${teamId}`);
      }
      if (teamSelected) {
        params.push(`team_id=${teamSelected}`);
      }
      if (date) {
        params.push(`month=${date}`);
      }
      if (selectedMember) {
        params.push(`user_id=${selectedMember.id}`);
      }

      const queryString =
        params.length > 0 ? `${members ? `&` : '?'}${params.join('&')}` : '';
      const url = `${apiUrl}/scores/${members ? 'members' : 'teams'}${members ? `?page=${page + 1}` : ''}${queryString}`;
      const res = await httpClient(url);
      if (res.status === 200) {
        const data = await res.json;
        setTotalPerPage(data.total || 0);
        setData(
          teamSelected && !members ? data.data.members_scores : data.data
        );
      }
    } catch (error) {
      console.error('Failed to fetch metrics:', error);
    }
  };

  const getTeams = async () => {
    try {
      const url = `${apiUrl}/teams`;
      const res = await httpClient(url);
      if (res.status === 200) {
        const data = await res.json.data;
        setTeams(data);
      }
    } catch (error) {
      console.error('Failed to fetch metrics:', error);
    }
  };

  useEffect(() => {
    if (!userLoading) {
      getResults();
    }
    getTeams();
  }, [teamSelected, date, page, selectedMember, userLoading]); //eslint-disable-line react-hooks/exhaustive-deps

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  return (
    <Card
      elevation={0}
      sx={{
        background: '#fff',
        color: '#000',
        padding: '24px',
        marginTop: 2,
        marginBottom: '1em',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '16px',
        }}
      >
        <Typography fontSize={26} fontWeight="600" sx={{ padding: '4px 0' }}>
          {title}
        </Typography>

        {!members ? (
          <SelectFieldTeams
            teamSelected={teamSelected}
            setTeam={setTeam}
            teams={teams}
          />
        ) : (
          <AutocompleteSelectFieldMembers
            selectedMember={selectedMember}
            setSelectedMember={setSelectedMember}
            setPage={setPage}
            team_id={teamId}
          />
        )}
      </Box>
      {data?.length === 0 ? (
        <Typography
          style={{
            fontSize: '20px',
            height: '100px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#737373',
          }}
        >
          {t('ra.navigation.no_results')}
        </Typography>
      ) : (
        <CardContent sx={{ padding: 0 }}>
          <TableContainer component={Paper}>
            <ResultsTable
              data={data}
              teamSelected={teamSelected}
              members={members}
              teams={teams}
              page={page}
              rowsPerPage={rowsPerPage}
            />
          </TableContainer>
          {members ? (
            <TablePagination
              component="div"
              count={totalPerPage}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPageOptions={[]}
            />
          ) : null}
        </CardContent>
      )}
    </Card>
  );
};
